/*eslint-disable*/
import React, { useState } from 'react';
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";;
import { useDispatch, useSelector } from "react-redux";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import FooterSection from "trade-customer-portal/views/footer.js"
import HeaderSection from "trade-customer-portal/views/header.js";
import ResetPasswordInput from "trade-customer-portal/views/ForgottenPasswordPage/Classes/ResetPasswaordInput.js";
import { useParams, useSearchParams } from 'react-router-dom';
import LoadingData from '../lottieLoading.js';

import { useHistory } from "react-router-dom";

// styling 
import style from "../../../assets/jss/CustomerTradePortal/views/adminPageStyle";
const useStyles = makeStyles(style);


// Landing Page for customer trade portal 
export default function ForgottenPasswordPage() {
    const [verified, setVerified] = useState(false);


    const loading = useSelector(state => state.userReducer.loadingPage);

    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        tokenValidCheck();
    }, []);

    const classes = useStyles();

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    let token = params.token; // "some_value"

    let userEmail = params.email; // "some_value"

    let history = useHistory();


    async function tokenValidCheck() {
        try {


            const response = await fetch('api/auth/checkAcessToken/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ConfirmationCode: token,
                    EmailAddress: userEmail
                })
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorised request");
                    }
                    return response;
                })
                .then(res => res.json())
                .catch();


            if (response) {
                setVerified(true)
            }
            else {
                setVerified(false)
                history.push('/error-page');
            }

        } catch (e) {

        }
    }



    if (verified) {
        return (
            <div >
                <HeaderSection />

                <Parallax
                    image={require("assets/img/passwordBanner.png")}
                    filter="dark"
                    xsmall
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={7}
                                sm={8}
                                className={classNames(
                                    classes.mlAuto,
                                    classes.mrAuto,
                                    classes.textCenter
                                )}
                            >
                                <h1 className={classes.title}> Reset Password</h1>
                            </GridItem>
                        </GridContainer>

                    </div>
                </Parallax>


                <div className={classNames(classes.main, classes.mainRaised)} >
                    <div className={classes.container} >
                        <ResetPasswordInput token={token} userEmail={userEmail} />
                    </div>
                </div>


                <FooterSection />
            </div>
        );

    }
    else {
        return (<LoadingData text={"Verifying Account Please..."} />)
    }



}


